import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardMedia,
  useTheme,
  IconButton,
} from "@mui/material";
import { imageBaseURL } from "actions/Base_URL";

const ImageCarouselInfo = ({ images }) => {
  const theme = useTheme();
  const imagesURLs = images.map((img)=>{
    return `${imageBaseURL}${img}`;
  })
  const [activeStep, setActiveStep] = useState(0);
  const maxSteps = images.length;

  const handleNext = () => setActiveStep((prev) => prev + 1);
  const handleBack = () => setActiveStep((prev) => prev - 1);

  return (
    <Box sx={{ maxWidth: "100%", flexGrow: 1, position: "relative" }}>
      <Card sx={{ height: 550, width: "100%", position: "relative" }}>
        <CardMedia
          component="img"
          image={imagesURLs[activeStep]}
          alt={`carousel-${activeStep}`}
          sx={{ width: "100%", height: "100%", objectFit: "contain", backgroundColor:"black" }}
        />

        {/* Navigation Buttons */}
        <Box
          sx={{
            position: "absolute",
            bottom: 10,
            width: "100%",
            px: 2,
            display: "flex",
            justifyContent: "space-between",
            zIndex: 1,
          }}
        >
          <Button
            size="small"
            onClick={handleBack}
            disableRipple
            disableFocusRipple
            disabled={activeStep === 0}
            sx={{ color: "white", backgroundColor: "rgba(155, 154, 154, 0.6)" }}
          >
            {"<"}
          </Button>
          <Button
            size="small"
            disableRipple
            disableFocusRipple
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
            sx={{ color: "white", backgroundColor: "rgba(155, 154, 154, 0.6)" }}
          >
            {">"}
          </Button>
        </Box>

        {/* Custom Dots */}
        <Box
          sx={{
            position: "absolute",
            bottom: 10,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            gap: 1,
          }}
        >
          {images.map((_, index) => (
            <Box
              key={index}
              sx={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                backgroundColor: index === activeStep ? "black" : "gray",
              }}
            />
          ))}
        </Box>
      </Card>
    </Box>
  );
};

export default ImageCarouselInfo;
